// Feature flags — driven by environment variables.
// Set REACT_APP_AGENT_ENABLED=true in .env.development / Vercel env vars to enable.
const features = {
  agentEnabled: process.env.REACT_APP_AGENT_ENABLED === 'true',
};

export default features;
